import { Container, ScrollView, SizableText, Spinner, Stack } from '@my/ui'
import { MainLayout, Meta, NativePageNavigation, StructuredMeta } from 'app/components'
import { BlockRenderer } from 'app/features/shared/blocks'
import { StaticContentPagesQueryOutput } from './queries'
import { SolitoImage } from 'solito/image'
import { RefreshControl } from 'react-native'
import config from 'app/config'

export interface StaticContentScreenProps {
  loading: boolean
  page?: StaticContentPagesQueryOutput['StaticContentPages']['docs'][0]

  refreshing: boolean
  onPullToRefresh: () => void
}

export const StaticContentScreen = (props: StaticContentScreenProps) => {
  if (props.loading || !props.page) {
    return (
      <MainLayout>
        <Container size="base" flex={1} minHeight={100} jc="center">
          <Spinner />
        </Container>
      </MainLayout>
    )
  }

  return (
    <MainLayout>
      <Meta title={props.page.title} />
      <StructuredMeta
        type="article"
        title={props.page.title}
        description={''}
        image={props.page.featuredImage?.url}
        date={props.page.updatedAt}
        url={`${config.siteUrl}/${props.page.slug}`}
      />
      <NativePageNavigation title={props.page.title} />
      <ScrollView
        refreshControl={
          <RefreshControl refreshing={props.refreshing} onRefresh={props.onPullToRefresh} />
        }
      >
        <Container size="base" gutter="gtSm" spaceBottom>
          {props.page.featuredImage && (
            <Stack w="100%" aspectRatio={39 / 20} $gtSm={{ aspectRatio: 5 / 2 }}>
              <SolitoImage
                priority
                src={props.page.featuredImage.url}
                alt={props.page.featuredImage.alt || props.page.title}
                fill
                contentFit="cover"
                sizes="(max-width: 768px) 100vw, 900px"
              />
            </Stack>
          )}

          <Container pt="$3.5" bg={props.page.isBasic ? undefined : '$white'} gutter size="base">
            {props.page.hideTitle || (
              <SizableText size="$7" fow="600" pb="$3.5">
                {props.page.title}
              </SizableText>
            )}
          </Container>

          <Container bc={props.page.isBasic ? undefined : '$white'} bblr="$3" bbrr="$3" pb="$3.5">
            <BlockRenderer content={props.page.content} />
          </Container>
        </Container>
      </ScrollView>
    </MainLayout>
  )
}
